import styled from "styled-components";
import {RegulatoryDataComponent} from "../../../../header/top-header-left/regulatory-data/regulatory-data.component";

export const VideoSlideRegulatoryDataComponent = styled(RegulatoryDataComponent)`
    position: static;
`